import { appConfig } from './app/app.config';
import { enableProdMode, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';
import { AppRootComponent } from './app/app-root.component';
import { bootstrapApplication } from '@angular/platform-browser';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppRootComponent, appConfig).catch(err => console.error(err));
